export default [
  { value: 'AF', label: '아프가니스탄 (AF)' },
  { value: 'AX', label: '올란드 제도 (AX)' },
  { value: 'AL', label: '알바니아 (AL)' },
  { value: 'DZ', label: '알제리 (DZ)' },
  { value: 'AS', label: '아메리칸사모아 (AS)' },
  { value: 'AD', label: '안도라 (AD)' },
  { value: 'AO', label: '앙골라 (AO)' },
  { value: 'AI', label: '앵귈라 (AI)' },
  { value: 'AG', label: '앤티가 바부다 (AG)' },
  { value: 'AR', label: '아르헨티나 (AR)' },
  { value: 'AM', label: '아르메니아 (AM)' },
  { value: 'AW', label: '아루바 (AW)' },
  { value: 'AU', label: '오스트레일리아 (AU)' },
  { value: 'AT', label: '오스트리아 (AT)' },
  { value: 'AZ', label: '아제르바이잔 (AZ)' },
  { value: 'BS', label: '바하마 (BS)' },
  { value: 'BH', label: '바레인 (BH)' },
  { value: 'BD', label: '방글라데시 (BD)' },
  { value: 'BB', label: '바베이도스 (BB)' },
  { value: 'BY', label: '벨라루스 (BY)' },
  { value: 'BE', label: '벨기에 (BE)' },
  { value: 'BZ', label: '벨리즈 (BZ)' },
  { value: 'BJ', label: '베냉 (BJ)' },
  { value: 'BM', label: '버뮤다 (BM)' },
  { value: 'BT', label: '부탄 (BT)' },
  { value: 'BO', label: '볼리비아 (BO)' },
  { value: 'BQ', label: '보네르, 신트 외스타티위스, 사바 (BQ)' },
  { value: 'BA', label: '보스니아 헤르체고비나 (BA)' },
  { value: 'BW', label: '보츠와나 (BW)' },
  { value: 'BV', label: '부베 섬 (BV)' },
  { value: 'BR', label: '브라질 (BR)' },
  { value: 'IO', label: '영국령 인도양 지역 (IO)' },
  { value: 'BN', label: '브루나이 (BN)' },
  { value: 'BG', label: '불가리아 (BG)' },
  { value: 'BF', label: '부르키나파소 (BF)' },
  { value: 'BI', label: '부룬디 (BI)' },
  { value: 'CV', label: '카보베르데 (CV)' },
  { value: 'KH', label: '캄보디아 (KH)' },
  { value: 'CM', label: '카메룬 (CM)' },
  { value: 'CA', label: '캐나다 (CA)' },
  { value: 'KY', label: '케이맨 제도 (KY)' },
  { value: 'CF', label: '중앙아프리카공화국 (CF)' },
  { value: 'TD', label: '차드 (TD)' },
  { value: 'CL', label: '칠레 (CL)' },
  { value: 'CN', label: '중국 (CN)' },
  { value: 'CX', label: '크리스마스 섬 (CX)' },
  { value: 'CC', label: '코코스 제도 (CC)' },
  { value: 'CO', label: '콜롬비아 (CO)' },
  { value: 'KM', label: '코모로 (KM)' },
  { value: 'CG', label: '콩고 공화국 (CG)' },
  { value: 'CD', label: '콩고 민주공화국 (CD)' },
  { value: 'CK', label: '쿡 제도 (CK)' },
  { value: 'CR', label: '코스타리카 (CR)' },
  { value: 'CI', label: '코트디부아르 (CI)' },
  { value: 'HR', label: '크로아티아 (HR)' },
  { value: 'CU', label: '쿠바 (CU)' },
  { value: 'CW', label: '퀴라소 (CW)' },
  { value: 'CY', label: '키프로스 (CY)' },
  { value: 'CZ', label: '체코 (CZ)' },
  { value: 'DK', label: '덴마크 (DK)' },
  { value: 'DJ', label: '지부티 (DJ)' },
  { value: 'DM', label: '도미니카 (DM)' },
  { value: 'DO', label: '도미니카 공화국 (DO)' },
  { value: 'EC', label: '에콰도르 (EC)' },
  { value: 'EG', label: '이집트 (EG)' },
  { value: 'SV', label: '엘살바도르 (SV)' },
  { value: 'GQ', label: '적도 기니 (GQ)' },
  { value: 'ER', label: '에리트레아 (ER)' },
  { value: 'EE', label: '에스토니아 (EE)' },
  { value: 'SZ', label: '에스와티니 (SZ)' },
  { value: 'ET', label: '에티오피아 (ET)' },
  { value: 'FK', label: '포클랜드 제도 (FK)' },
  { value: 'FO', label: '페로 제도 (FO)' },
  { value: 'FJ', label: '피지 (FJ)' },
  { value: 'FI', label: '핀란드 (FI)' },
  { value: 'FR', label: '프랑스 (FR)' },
  { value: 'GF', label: '프랑스령 기아나 (GF)' },
  { value: 'PF', label: '프랑스령 폴리네시아 (PF)' },
  { value: 'TF', label: '프랑스령 남방 및 남극 지역 (TF)' },
  { value: 'GA', label: '가봉 (GA)' },
  { value: 'GM', label: '감비아 (GM)' },
  { value: 'GE', label: '조지아 (GE)' },
  { value: 'DE', label: '독일 (DE)' },
  { value: 'GH', label: '가나 (GH)' },
  { value: 'GI', label: '지브롤터 (GI)' },
  { value: 'GR', label: '그리스 (GR)' },
  { value: 'GL', label: '그린란드 (GL)' },
  { value: 'GD', label: '그레나다 (GD)' },
  { value: 'GP', label: '과들루프 (GP)' },
  { value: 'GU', label: '괌 (GU)' },
  { value: 'GT', label: '과테말라 (GT)' },
  { value: 'GG', label: '건지 (GG)' },
  { value: 'GN', label: '기니 (GN)' },
  { value: 'GW', label: '기니비사우 (GW)' },
  { value: 'GY', label: '가이아나 (GY)' },
  { value: 'HT', label: '아이티 (HT)' },
  { value: 'HM', label: '허드 맥도널드 제도 (HM)' },
  { value: 'VA', label: '바티칸 시국 (VA)' },
  { value: 'HN', label: '온두라스 (HN)' },
  { value: 'HK', label: '홍콩 (HK)' },
  { value: 'HU', label: '헝가리 (HU)' },
  { value: 'IS', label: '아이슬란드 (IS)' },
  { value: 'IN', label: '인도 (IN)' },
  { value: 'ID', label: '인도네시아 (ID)' },
  { value: 'IR', label: '이란 (IR)' },
  { value: 'IQ', label: '이라크 (IQ)' },
  { value: 'IE', label: '아일랜드 (IE)' },
  { value: 'IM', label: '맨 섬 (IM)' },
  { value: 'IL', label: '이스라엘 (IL)' },
  { value: 'IT', label: '이탈리아 (IT)' },
  { value: 'JM', label: '자메이카 (JM)' },
  { value: 'JP', label: '일본 (JP)' },
  { value: 'JE', label: '저지 (JE)' },
  { value: 'JO', label: '요르단 (JO)' },
  { value: 'KZ', label: '카자흐스탄 (KZ)' },
  { value: 'KE', label: '케냐 (KE)' },
  { value: 'KI', label: '키리바시 (KI)' },
  { value: 'KP', label: '북한 (KP)' },
  { value: 'KR', label: '대한민국 (KR)' },
  { value: 'KW', label: '쿠웨이트 (KW)' },
  { value: 'KG', label: '키르기스스탄 (KG)' },
  { value: 'LA', label: '라오스 (LA)' },
  { value: 'LV', label: '라트비아 (LV)' },
  { value: 'LB', label: '레바논 (LB)' },
  { value: 'LS', label: '레소토 (LS)' },
  { value: 'LR', label: '라이베리아 (LR)' },
  { value: 'LY', label: '리비아 (LY)' },
  { value: 'LI', label: '리히텐슈타인 (LI)' },
  { value: 'LT', label: '리투아니아 (LT)' },
  { value: 'LU', label: '룩셈부르크 (LU)' },
  { value: 'MO', label: '마카오 (MO)' },
  { value: 'MG', label: '마다가스카르 (MG)' },
  { value: 'MW', label: '말라위 (MW)' },
  { value: 'MY', label: '말레이시아 (MY)' },
  { value: 'MV', label: '몰디브 (MV)' },
  { value: 'ML', label: '말리 (ML)' },
  { value: 'MT', label: '몰타 (MT)' },
  { value: 'MH', label: '마셜 제도 (MH)' },
  { value: 'MQ', label: '마르티니크 (MQ)' },
  { value: 'MR', label: '모리타니 (MR)' },
  { value: 'MU', label: '모리셔스 (MU)' },
  { value: 'YT', label: '마요트 (YT)' },
  { value: 'MX', label: '멕시코 (MX)' },
  { value: 'FM', label: '미크로네시아 연방 (FM)' },
  { value: 'MD', label: '몰도바 (MD)' },
  { value: 'MC', label: '모나코 (MC)' },
  { value: 'MN', label: '몽골 (MN)' },
  { value: 'ME', label: '몬테네그로 (ME)' },
  { value: 'MS', label: '몬트세랫 (MS)' },
  { value: 'MA', label: '모로코 (MA)' },
  { value: 'MZ', label: '모잠비크 (MZ)' },
  { value: 'MM', label: '미얀마 (MM)' },
  { value: 'NA', label: '나미비아 (NA)' },
  { value: 'NR', label: '나우루 (NR)' },
  { value: 'NP', label: '네팔 (NP)' },
  { value: 'NL', label: '네덜란드 (NL)' },
  { value: 'NC', label: '뉴칼레도니아 (NC)' },
  { value: 'NZ', label: '뉴질랜드 (NZ)' },
  { value: 'NI', label: '니카라과 (NI)' },
  { value: 'NE', label: '니제르 (NE)' },
  { value: 'NG', label: '나이지리아 (NG)' },
  { value: 'NU', label: '니우에 (NU)' },
  { value: 'NF', label: '노퍽 섬 (NF)' },
  { value: 'MK', label: '북마케도니아 (MK)' },
  { value: 'MP', label: '북마리아나 제도 (MP)' },
  { value: 'NO', label: '노르웨이 (NO)' },
  { value: 'OM', label: '오만 (OM)' },
  { value: 'PK', label: '파키스탄 (PK)' },
  { value: 'PW', label: '팔라우 (PW)' },
  { value: 'PS', label: '팔레스타인 (PS)' },
  { value: 'PA', label: '파나마 (PA)' },
  { value: 'PG', label: '파푸아뉴기니 (PG)' },
  { value: 'PY', label: '파라과이 (PY)' },
  { value: 'PE', label: '페루 (PE)' },
  { value: 'PH', label: '필리핀 (PH)' },
  { value: 'PN', label: '핏케언 제도 (PN)' },
  { value: 'PL', label: '폴란드 (PL)' },
  { value: 'PT', label: '포르투갈 (PT)' },
  { value: 'PR', label: '푸에르토리코 (PR)' },
  { value: 'QA', label: '카타르 (QA)' },
  { value: 'RE', label: '레위니옹 (RE)' },
  { value: 'RO', label: '루마니아 (RO)' },
  { value: 'RU', label: '러시아 (RU)' },
  { value: 'RW', label: '르완다 (RW)' },
  { value: 'BL', label: '생바르텔레미 (BL)' },
  { value: 'SH', label: '세인트헬레나 (SH)' },
  { value: 'KN', label: '세인트키츠 네비스 (KN)' },
  { value: 'LC', label: '세인트루시아 (LC)' },
  { value: 'MF', label: '생마르탱 (MF)' },
  { value: 'PM', label: '생피에르 미클롱 (PM)' },
  { value: 'VC', label: '세인트빈센트 그레나딘 (VC)' },
  { value: 'WS', label: '사모아 (WS)' },
  { value: 'SM', label: '산마리노 (SM)' },
  { value: 'ST', label: '상투메 프린시페 (ST)' },
  { value: 'SA', label: '사우디아라비아 (SA)' },
  { value: 'SN', label: '세네갈 (SN)' },
  { value: 'RS', label: '세르비아 (RS)' },
  { value: 'SC', label: '세이셸 (SC)' },
  { value: 'SL', label: '시에라리온 (SL)' },
  { value: 'SG', label: '싱가포르 (SG)' },
  { value: 'SX', label: '신트마르턴 (SX)' },
  { value: 'SK', label: '슬로바키아 (SK)' },
  { value: 'SI', label: '슬로베니아 (SI)' },
  { value: 'SB', label: '솔로몬 제도 (SB)' },
  { value: 'SO', label: '소말리아 (SO)' },
  { value: 'ZA', label: '남아프리카 공화국 (ZA)' },
  { value: 'GS', label: '사우스조지아 사우스샌드위치 제도 (GS)' },
  { value: 'SS', label: '남수단 (SS)' },
  { value: 'ES', label: '스페인 (ES)' },
  { value: 'LK', label: '스리랑카 (LK)' },
  { value: 'SD', label: '수단 (SD)' },
  { value: 'SR', label: '수리남 (SR)' },
  { value: 'SJ', label: '스발바르 얀마옌 (SJ)' },
  { value: 'SE', label: '스웨덴 (SE)' },
  { value: 'CH', label: '스위스 (CH)' },
  { value: 'SY', label: '시리아 (SY)' },
  { value: 'TW', label: '대만 (TW)' },
  { value: 'TJ', label: '타지키스탄 (TJ)' },
  { value: 'TZ', label: '탄자니아 (TZ)' },
  { value: 'TH', label: '태국 (TH)' },
  { value: 'TL', label: '동티모르 (TL)' },
  { value: 'TG', label: '토고 (TG)' },
  { value: 'TK', label: '토켈라우 (TK)' },
  { value: 'TO', label: '통가 (TO)' },
  { value: 'TT', label: '트리니다드 토바고 (TT)' },
  { value: 'TN', label: '튀니지 (TN)' },
  { value: 'TR', label: '터키 (TR)' },
  { value: 'TM', label: '투르크메니스탄 (TM)' },
  { value: 'TC', label: '터크스 케이커스 제도 (TC)' },
  { value: 'TV', label: '투발루 (TV)' },
  { value: 'UG', label: '우간다 (UG)' },
  { value: 'UA', label: '우크라이나 (UA)' },
  { value: 'AE', label: '아랍에미리트 (AE)' },
  { value: 'GB', label: '영국 (GB)' },
  { value: 'US', label: '미국 (US)' },
  { value: 'UM', label: '미국령 군소 제도 (UM)' },
  { value: 'UY', label: '우루과이 (UY)' },
  { value: 'UZ', label: '우즈베키스탄 (UZ)' },
  { value: 'VU', label: '바누아투 (VU)' },
  { value: 'VE', label: '베네수엘라 (VE)' },
  { value: 'VN', label: '베트남 (VN)' },
  { value: 'VG', label: '영국령 버진아일랜드 (VG)' },
  { value: 'VI', label: '미국령 버진아일랜드 (VI)' },
  { value: 'WF', label: '왈리스 푸투나 (WF)' },
  { value: 'EH', label: '서사하라 (EH)' },
  { value: 'YE', label: '예멘 (YE)' },
  { value: 'ZM', label: '잠비아 (ZM)' },
  { value: 'ZW', label: '짐바브웨 (ZW)' },
]
